import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    carInfo: {}
  },
  mutations: {
    SET_CAR_INFO: (state, carInfo) => {
      state.carInfo = carInfo
    }
  },
  actions: {
    setCarInfo({ commit }, carInfo) {
      commit('SET_CAR_INFO', carInfo)
    }
  },
  modules: {}
})
